import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MenuCategory, MenuPdf } from 'types/Menu';
import { getMenu, getMenuPdf } from 'store/reducers/MenuSlice/ActionCreators';

interface MenuState {
  menu: MenuCategory[];
  menuPdf: MenuPdf[];
  isLoading: boolean;
  error: string;
  filterQuery: string;
  filterQueryInput: string;
}

const initialState: MenuState = {
  menu: [],
  menuPdf: [],
  isLoading: false,
  error: '',
  filterQuery: '',
  filterQueryInput: '',
};

export const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setFilterQuery: (state, action: PayloadAction<string>) => {
      state.filterQuery = action.payload;
    },
    setFilterQueryInput: (state, action: PayloadAction<string>) => {
      state.filterQueryInput = action.payload;
    },
  },
  extraReducers: {
    [getMenu.fulfilled.type]: (
      state,
      action: PayloadAction<MenuCategory[]>
    ) => {
      state.isLoading = false;
      state.error = '';
      state.menu = action.payload;
    },
    [getMenu.pending.type]: (state) => {
      state.isLoading = true;
    },
    [getMenu.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    [getMenuPdf.fulfilled.type]: (state, action: PayloadAction<MenuPdf[]>) => {
      state.isLoading = false;
      state.error = '';
      state.menuPdf = action.payload;
    },
    [getMenuPdf.pending.type]: (state) => {
      state.isLoading = true;
    },
    [getMenuPdf.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default menuSlice.reducer;
